import { NonAvailableAgentsSettingsBuilder } from "./non-available-agents-settings.builder";
import { OutOfBusinessHoursSettingsBuilder } from "./out-of-business-hours-settings.builder";
import { WaitOfferSettingsBuilder } from "./wait-offer-settings-builder";
var CallCenterSettingsBuilder = /** @class */ (function () {
    function CallCenterSettingsBuilder() {
        this.callCenterSettings = {
            nonAvailableAgentsSettings: new NonAvailableAgentsSettingsBuilder().build(),
            outOfBusinessHoursSettings: new OutOfBusinessHoursSettingsBuilder().build(),
            waitOfferSettings: new WaitOfferSettingsBuilder().build()
        };
    }
    CallCenterSettingsBuilder.prototype.withNonAvailableAgentsSettings = function (settings) {
        this.callCenterSettings.nonAvailableAgentsSettings = settings;
        return this;
    };
    CallCenterSettingsBuilder.prototype.withOutOfBusinessHoursSettings = function (settings) {
        this.callCenterSettings.outOfBusinessHoursSettings = settings;
        return this;
    };
    CallCenterSettingsBuilder.prototype.withWaitOfferSettings = function (settings) {
        this.callCenterSettings.waitOfferSettings = settings;
        return this;
    };
    CallCenterSettingsBuilder.prototype.build = function () {
        return this.callCenterSettings;
    };
    return CallCenterSettingsBuilder;
}());
export { CallCenterSettingsBuilder };
//# sourceMappingURL=call-center-settings.builder.js.map